










import Vue from 'vue';
import { ChevronDownIcon } from 'vue-feather-icons';

export default Vue.extend({
  name: 'IconTokenSelectArrow',
  components: {
    ChevronDownIcon,
  },
});
